export * from "./legacy";
export { permissionsApi, useGetPermissionsQuery, useGetUserPermissionsQuery } from "./rtk";
